var Perseides = Perseides || {};
(function ($, window, document, Perseides, Analyzr, undefined) {
    "use strict";

    window.PerseidesJquery = function () {
        var app = this;

        /**
         * Extension jQuery
         */
        $.fn.extend({

            outerHTML: function(s) {
                return s
                    ? this.before(s).remove()
                    : jQuery("<p>").append(this.eq(0).clone()).html();
            },

	        // Custom Select Boxes
	        customSelect: function (scriptOptions) {
		        var customSelect = this;
		        customSelect.blurCancelation = false;

		        //Defaults
		        customSelect.defaults = {
			        cssClassPrefix: 'custom-select' //Class prefix that will be used for all class names that are needed for the custom <select> control
		        };

		        //Options
		        customSelect.options = $.extend(customSelect.defaults, scriptOptions);

		        //Fonction to get the <select> link with the custom options box or option item
		        customSelect.getSelectFromEventTarget = function (target) {
			        return $(target).closest('.custom-select').find('select');
		        };

		        //onMouseEnter Handler
		        customSelect.mouseEnterHandler = function () {
			        customSelect.blurCancelation = true;
		        };

		        //onMouseLeave Handler
		        customSelect.mouseLeaveHandler = function () {
			        customSelect.blurCancelation = false;
		        };

		        //onClick Handler
		        customSelect.clickHandler = function (event) {
			        var optionClasses = event.target.className.split(' '),
			            classAccepted = customSelect.options.cssClassPrefix + '__options--option',
			            classRefused = customSelect.options.cssClassPrefix + '__options--option--disabled';

			        if ($.inArray(classRefused, optionClasses) < 0 && $.inArray(classAccepted, optionClasses) !== -1) {
				        customSelect.changeHandler(event);
			        }
			        else {
				        customSelect.getSelectFromEventTarget(event.target).focus();
			        }
		        };

		        //onChange Handler
		        customSelect.changeHandler = function (event) {
			        var thisSelect = $(this),
			            is_triggeredFromCustomOption = false;

			        //If the event is coming from a click on an option, then find the real select from the option's parent
			        if (event.type === 'click') {
				        var targetClasses = event.target.className.split(' '),
				            classToFind = customSelect.options.cssClassPrefix + '__options--option';

				        if ($.inArray(classToFind, targetClasses) !== -1) {
					        thisSelect = customSelect.getSelectFromEventTarget(event.target);
					        is_triggeredFromCustomOption = true;
				        }
			        }

			        var thisCustomSelect = thisSelect.parent(),
			            thisCustomSelectOptionsContainer = thisCustomSelect.find('.' + customSelect.options.cssClassPrefix + '__options'),
			            thisCustomSelectOptions = thisCustomSelect.find('.' + customSelect.options.cssClassPrefix + '__options--option');

			        setTimeout(function () {
				        var optionSelectedText,
				            optionSelectedValue;

				        //If the event is coming from a click on an option, then we adjust the results
				        if (is_triggeredFromCustomOption === true) {
					        optionSelectedText = event.target.innerHTML;
					        optionSelectedValue = $(event.target).data('value').toString();
					        thisSelect.val($(event.target).data('value'));
				        }
				        else {
					        optionSelectedText = thisSelect.find(':selected').text();
					        optionSelectedValue = thisSelect.find(':selected').val().toString();
				        }

				        //Put selected option's text into the custom select's selected item SPAN
				        thisCustomSelect.find('.' + customSelect.options.cssClassPrefix + '__value').text(optionSelectedText);

				        //Pass through this select options list and put a "selected" class on the option in the custom select
				        var positionTop = 0;
				        thisCustomSelectOptions.each(function () {
					        var optionClass = customSelect.options.cssClassPrefix + '__options--option--selected';

					        if ($(this).text() === optionSelectedText && $(this).data('value').toString() === optionSelectedValue) {
						        $(this).addClass(optionClass);
						        thisCustomSelectOptionsContainer.scrollTop(positionTop);
					        }
					        else {
						        $(this).removeClass(optionClass);
					        }

					        //Get option's height to be able to know the top position
					        positionTop += $(this).outerHeight(true);
				        });

				        //If the option selected have no value, then add a "default" class, else remove it
				        //The purpose is when the first option is a "placeholder"
				        if (!thisSelect.val()) {
					        thisCustomSelect.addClass(customSelect.options.cssClassPrefix + '--default');
				        }
				        else {
					        thisCustomSelect.removeClass(customSelect.options.cssClassPrefix + '--default');
				        }

				        //If this select box is disabled, add the appropriate class to the custom select
				        if (typeof thisSelect.attr('disabled') !== 'undefined' && thisSelect.attr('disabled') !== false) {
					        thisCustomSelect.addClass(customSelect.options.cssClassPrefix + '--disabled');
				        }

				        //If the "Enter" key is press, then close the custom options list
				        //Key "which" table : https://css-tricks.com/snippets/javascript/javascript-keycodes/
				        if (event.type === 'click' || event.which === 13) {
					        customSelect.blurCancelation = false;
					        customSelect.getSelectFromEventTarget(event.target).blur();
					        thisCustomSelectOptionsContainer.scrollTop(0);
				        }
			        }, 0);
		        };

		        //onFocus Handler
		        customSelect.focusHandler = function () {
			        $(this).parent().addClass(customSelect.options.cssClassPrefix + '--focused');
		        };

		        //onBlur Handler
		        customSelect.blurHandler = function () {
			        var thisSelect = $(this);

			        if (customSelect.blurCancelation !== true) {
				        thisSelect.parent().removeClass(customSelect.options.cssClassPrefix + '--focused');
				        _.debounce(function () {
					        thisSelect.blur()
				        });
			        }
			        else {
				        _.debounce(function () {
					        thisSelect.focus()
				        });
			        }
		        };

		        return this.each(function () {
			        var thisSelect = $(this),
			            thisSelectOptions = $(this).find('option'),
			            thisSelectParent = thisSelect.parent(),
			            currentSelected = thisSelect.find(':selected'),
			            currentSelectedText = currentSelected.text();

			        //Wrap this select box in a controller span
			        thisSelect.wrap('<span class="' + customSelect.options.cssClassPrefix + '"></span>');

			        //If this select box is disabled, add the appropriate class to the custom select
			        if (typeof thisSelect.attr('disabled') !== 'undefined' && thisSelect.attr('disabled') !== false) {
				        thisSelect.parent().addClass(customSelect.options.cssClassPrefix + '--disabled');
			        }

			        //Hide the actual <select> control (using opacity so it's still focusable/actionable)
			        thisSelect.css({
				        opacity: 0
			        });

			        //Create HTML for options list
			        var thisOptionsMainClass = customSelect.options.cssClassPrefix + '__options',
			            thisOptionsHTML = '<span class="' + thisOptionsMainClass + '">';

			        thisSelectOptions.each(function () {
				        var thisOptionMainClass = thisOptionsMainClass + '--option',
				            thisOptionClasses = '';

				        if ($(this).attr('disabled') !== undefined && $(this).attr('disabled') !== false) {
					        thisOptionClasses += ' ' + thisOptionMainClass + '--disabled';
				        }

				        if ($(this).attr('selected') !== undefined && $(this).attr('selected') !== false) {
					        thisOptionClasses += ' ' + thisOptionMainClass + '--selected';
				        }

				        thisOptionsHTML += '<span class="' + thisOptionMainClass + thisOptionClasses + '" data-value="' + $(this).val() + '">' + $(this).text() + '</span>';
			        });
			        thisOptionsHTML += '</span>';

			        //Add additional markup for custom select
			        // data-icon="error" data-icon-element-class="formfield__error-icon"
			        $('<span class="' + customSelect.options.cssClassPrefix + '__outer"><span class="' + customSelect.options.cssClassPrefix + '__inner"><span class="' + customSelect.options.cssClassPrefix + '__value">' + currentSelectedText + '</span><span class="' + customSelect.options.cssClassPrefix + '__icon"><svg class="icon-fleche-bas-arrondie"><use xlink:href="#icon-fleche-bas-arrondie"/></svg></span></span>' + thisOptionsHTML + '</span>').insertAfter(thisSelect);

			        //Initialize custom select control based on current value
			        if (currentSelected.val() === '') {
				        thisSelect.parent().addClass(customSelect.options.cssClassPrefix + '--default');
			        }

			        //Error
			        if (thisSelectParent.hasClass('formfield--invalid')) {
				        thisSelect.parent().addClass(customSelect.options.cssClassPrefix + '--error');
			        }


			        var thisCustomSelectOptions = thisSelectParent.find('.' + customSelect.options.cssClassPrefix + '__options');

			        //Event bindings
			        thisCustomSelectOptions.on({
				        click: customSelect.clickHandler,
				        mouseenter: customSelect.mouseEnterHandler,
				        mouseleave: customSelect.mouseLeaveHandler
			        });
			        thisSelect.on({
				        change: customSelect.changeHandler,
				        focus: customSelect.focusHandler,
				        blur: customSelect.blurHandler,
				        //keyup: customSelect.changeHandler,
				        keypress: customSelect.changeHandler
			        });

		        });

	        },
        });

    };

    Perseides.Jquery = new PerseidesJquery();
}(jQuery, window, document, Perseides, Analyzr));